// 导出页面为PDF格式
import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
import 'jspdf-autotable'         //  cnpm install jspdf-autotable    // 下载完之后要修改源代码，否则表头还是中文乱码
import moo from '../../../../static/font/font'     // 中文字体文件

/**
 * @param  ele          要生成 pdf 的DOM元素（容器）
 * @param  padfName     PDF文件生成后的文件名字
 * */

function downloadPDF(titles,ele,object,ress,style){
    let data=[];
    for (const keys in object) {
        if (Object.hasOwnProperty.call(object, keys)) {
            data.push({header:object[keys].title,dataKey:object[keys].key});
        }
    }
    data.unshift({header: "序号", dataKey: "index"})
    var doc = new JsPDF('p', 'pt'); // 获取实例
    var res = doc.autoTableHtmlToJson(ele);    // 这是获取页面已有table的数据导出  ，顺序不能乱放，要不就会乱码，获取的basic-table可以传参
    
    // ===============================  设置字体
    doc.addFileToVFS('pingfang.ttf', moo)
    doc.addFont('pingfang.ttf', 'b', 'normal');

    doc.setFont('b');
    
    // ===============================
    var n = "#ffffff";
    style.transparent ? n="#ffffff" : n = style.tableBackgroundColor; 
    doc.autoTable({                  // 这是获取页面已有table的数据导出  ，顺序不能乱放，要不就会乱码
        styles: { fillColor: n, font: 'b', textColor: style.tableTextColor , halign: 'center',},    // 样式
        theme: 'grid',           // 主题
        startY: 60,          // 距离上边距离
        body: ress,        // tableDate
        columns: data,
        tableWidth: 'auto'
    })
    doc.setFontSize(style.fontSize);
    doc.setFont(style.fontName);
    // doc.text(40, 30, '个人号还挺好')      //  渲染title  // 可以传参
    // dom.src = doc.output('datauristring');   // 渲染pdf
    doc.save(titles);   // 导出pdf   // 名字可以传参


}


export default {
    downloadPDF
}




// WEBPACK FOOTER //
// ./src/components/primitives/fvLogging/exportPDF.js